module.exports = __webpack_public_path__ + "images/DPB2_3.4c9df6a79e91be45d90650b518892165.png";